
// VehicleBrand services rest api calling

import { routes } from '../config/api_routes'

export const vehicleBrandServices = {

    // get VehicleBrand 
    // info: sortDesc : Boolean
    
    getVehicleBrand: (formData) => window.axios.post(routes.getVehicleBrandApi,formData),

    // add VehicleBrand Type 

    addVehicleBrand: (formData) => window.axios.post(routes.addVehicleBrandApi,formData),

    // get VehicleBrandById 

    getVehicleBrandById: (formData) => window.axios.post(routes.getVehicleBrandApiById,formData),

    // update VehicleBrandById

    updateVehicleBrandById: (formData) => window.axios.post(routes.updateVehicleBrandApi,formData),

    // delete VehicleBrandById

    deleteVehicleBrandById: (formData) => window.axios.post(routes.deleteVehicleBrandApi,formData),
}